import React from 'react'
import Container from '../../../../components/Container'
import { FormOperationIndex } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const OperationIndexCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormOperationIndex typeForm="create" />
  </Container>
)

export default OperationIndexCreate
